import React from 'react';
import { Tables } from '@deeptrue-frontend/ui';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveModal from 'components/PromptModal/PromptModal';
import { useFormatMessage } from 'components/IntlProvider';

const { TableRow, TableCell } = Tables;

interface Props {
  displayName: string;
  email: string;
  id: number;
  removeUser: (id: number, email: string) => void;
}

const User = ({ displayName, email, id, removeUser }: Props) => {
  const t = useFormatMessage();
  return (
    <TableRow>
      <TableCell minWidth="150px" height="2rem" padding="0.5rem">
        {displayName}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {email}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem" width="80px" align="right">
        <Tooltip title={t('organization.unshare', 'Unshare')}>
          <span style={{ cursor: 'pointer' }}>
            <RemoveModal
              onConfirm={() => removeUser(id, email)}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              {t(
                'organization.confirmDelete',
                'Are you sure you want to remove {x} from {y}',
                {
                  x: email,
                  y: t('organization.product', 'product'),
                }
              )}
            </RemoveModal>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default User;
